export const ArrowDownOrder = (props) => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.478 9.44841L7.47776 15.7343C7.31594 15.904 7.09157 16 6.85721 16C6.62284 16 6.39848 15.904 6.23665 15.7343L0.236435 9.44841C-0.0894695 9.10579 -0.0771834 8.56334 0.265436 8.23633C0.604734 7.90932 1.1494 7.92157 1.47755 8.26533L6.00003 13.0036V0.857173C6.00003 0.383942 6.38398 0 6.85721 0C7.33044 0 7.71438 0.383942 7.71438 0.857173V13.0036L12.2369 8.26537C12.5639 7.9216 13.1085 7.90932 13.4489 8.23633C13.7916 8.56334 13.8039 9.10579 13.478 9.44841Z"
        fill="#737D86"
      />
    </svg>
  )
}
